import { alias, primitive, serializable } from 'serializr';

export class LocationYears {

    @serializable
    id?: number;

    @serializable
    year?: number;

    @serializable
    status?: boolean;

    @serializable(alias('is_active', primitive()))
    isActive?: boolean;

    @serializable(alias('share_percentage', primitive()))
    sharePercentage?: number | string;

}